import { all, takeEvery, put, call } from 'redux-saga/effects';
import { createBrowserHistory } from 'history';
import { notification } from '@iso/components';
import actions from './actions';
import ventasActions from '../ventas/actions';
import siteConfig from '@iso/config/site.config';
import opsActions from '../ops/actions';
const { SET_PERMISOS_OPERARIO } = opsActions;
const gaxios = require('gaxios');

const history = createBrowserHistory();

export function* loginRequest(action) {
  let ULRDestino = "api/auth/";
  let metodo = "POST";
  const res = yield gaxios.request({
    url: ULRDestino,
    method: metodo,
    data: action.payload,
  });
  if (res.data.success) {
    yield put({
      type: actions.LOGIN_SUCCESS,
      access_token: res.data.token,
      id_token: res.data.user.id,
      cdt: res.data.user.cdt,
      nombre: res.data.name,
      email: res.data.email,
      avatar: res.data.avatar,
      categoria: res.data.clasificacion,
      verificado: res.data.user.verificado,
      notificaciones: res.data.notificaciones,
      nivel: res.data.user.nivel,
      permisos: res.data.user.permisos,
    });

    yield put({
      type: SET_PERMISOS_OPERARIO,
      payload: res.data.user.cdt,
    });
    action.payload.history.push('/dashboard/my-profile');
  } else {
    yield put({
      type: actions.LOGIN_ERROR,
      msg: res.data.msg,
    });
  }
}

export function* loginRequestSiigo(action) {
  let ULRDestino = "api/auth/siigo";
  let metodo = "POST";
  const res = yield gaxios.request({
    url: ULRDestino,
    method: metodo,
    data: action.payload,
  });
  if (res.data.success) {

    yield put({
      type: actions.LOGIN_SUCCESS_SIIGO,
      siigo_token: res.data.siigo_token,
      siigo_login: true,
      request_siigo: false
    });
    yield localStorage.setItem('siigo_token', res.data.siigo_token);

  } else {
    yield put({
      type: actions.LOGIN_ERROR,
      msg: res.data.msg,
    });
  }
}

export function* recoveryRequest(action) {
  let ULRDestino = "api/auth/recovery/";
  let metodo = "POST";
  const res = yield gaxios.request({
    url: ULRDestino,
    method: metodo,
    data: { email: action.payload },
  });
  if (res.data.success) {
    yield clearToken();
    notification('success', res.data.msg);
    history.push('/');
  } else {
    yield put({
      type: actions.LOGIN_ERROR,
      msg: res.data.msg,
    });
  }
}

export function* setRecovery(action) {
  let ULRDestino = "api/auth/reset/";
  let metodo = "POST";
  const res = yield gaxios.request({
    url: ULRDestino,
    method: metodo,
    data: action.payload,
  });
  if (res.data.success) {
    notification('success', res.data.msg);
    yield put({
      type: actions.LOGIN_REQUEST,
      payload: { email: res.data.user.email, pass: action.payload.pass }
    });
  } else {
    notification('error', res.data.msg);
  }
}

export function* loginSuccess(action) {
  yield localStorage.setItem('access_token', action.access_token);
  yield localStorage.setItem('id_token', action.id_token);
}

export function* loginError(action) {
  try {
    yield call(notification, 'error', action.msg);
  } catch (error) {
    console.error('Error mostrando notificación:', error);
  }
}

export function* logout() {
  yield clearToken();
  history.push('/');
}


export function* checkAuthorization() {
  const idUser = localStorage.getItem('id_token');
  const token = localStorage.getItem('access_token');
  const siigoToken = localStorage.getItem('siigo_token');
  let ULRDestino = "api/auth/chk/" + idUser;
  let metodo = "POST";
  if (token && idUser) {
    const res = yield gaxios.request({
      url: ULRDestino,
      method: metodo,
      headers: {
        Authorization: token
      }
    });
    if (res.data.success) {
      yield put({
        type: actions.LOGIN_SUCCESS,
        id_token: idUser,
        access_token: token,
        siigoToken,
        siigo_login: siigoToken ? true : false,
        nombre: res.data.user.name,
        email: res.data.user.email,
        cdt: res.data.user.cdt,
        categoria: res.data.user.clasificacion,
        nivel: res.data.user.nivel,
        verificado: res.data.user.verificado,
        avatar: res.data.user.avatar ? `${siteConfig.siteUrl.IMG_PATH}/${res.data.user.avatar}` : null,
        notificaciones: res.data.user.notificaciones,
        permisos: res.data.user.permisos,
      });
      yield put({
        type: SET_PERMISOS_OPERARIO,
        payload: res.data.user.cdt,
      });
      
    } else {
      yield put({
        type: actions.LOGIN_ERROR,
        msg: res.data.msg,
      });
      yield put({
        type: actions.LOGOUT,
      });
    }
  }
}

export function* signupSaga(action) {
  let ULRDestino = "api/registro/";
  let metodo = "POST";
  const res = yield gaxios.request({
    url: ULRDestino,
    method: metodo,
    data: action.payload,
  });
  if (res.data.success) {
    if (res.data.isFromSale) {
      yield put({
        type: ventasActions.SET_CLIENTE,
        data: res.data.user
      });
    } else {
      yield put({
        type: actions.LOGIN_SUCCESS,
        access_token: res.data.token,
        id_token: res.data.user.id,
        cdt: res.data.user.cdt,
        nombre: res.data.name,
      });
    }
  } else {
    yield put({
      type: actions.LOGIN_ERROR,
      msg: res.data.msg,
    });
  }
}

function clearToken() {
  localStorage.removeItem('access_token');
  localStorage.removeItem('siigo_token');
  localStorage.removeItem('id_token');
}

export default function* rootSaga() {
  yield all([
    yield takeEvery(actions.LOGIN_ERROR, loginError),
    yield takeEvery(actions.LOGIN_SUCCESS, loginSuccess),
    yield takeEvery(actions.LOGIN_REQUEST, loginRequest),
    yield takeEvery(actions.LOGIN_REQUEST_SIIGO, loginRequestSiigo),
    yield takeEvery(actions.LOGOUT, logout),
    yield takeEvery(actions.CHECK_AUTHORIZATION, checkAuthorization),
    yield takeEvery(actions.LOGIN_SIGNUP, signupSaga),
    yield takeEvery(actions.PASS_RECOVERY, recoveryRequest),
    yield takeEvery(actions.SET_RECOVERY, setRecovery)
  ]);
}
